import styles from "./Crossword.module.scss";
import Image from "components/Image";
import SectionHeading from "./SectionHeading";
import crosswordPromoImage from "assets/images/crossword-promo.png";

const Crossword = () => {
  const crosswordUrl =
    "https://www.theatlantic.com/free-daily-crossword-puzzle/";
  const analyticsSlug = "crossword";

  return (
    <section data-testid="homepage-crossword">
      <SectionHeading
        title="Crossword"
        url={crosswordUrl}
        analyticsSlug={analyticsSlug}
      />
      <div className={styles.info}>
        <p className={styles.text}>
          Play the crossword that gets more challenging every weekday.
        </p>

        <Image
          className={styles.image}
          src={crosswordPromoImage}
          alt="The Atlantic Crossword Promo"
          lazy
          width={80}
          height={80}
        />
        <a
          href={crosswordUrl}
          className={styles.button}
          data-action={`click button - ${analyticsSlug}`}
          data-label="play crossword"
        >
          Play Crossword
        </a>
      </div>
    </section>
  );
};

export default Crossword;
